import * as React from "react";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

import Layout from "../../components/Layout";
import Seo from "../../components/Seo";

import NewsHeader from "../../components/NewsHeader";
import SleepyNewsAnchor from "../../components/SleepyNewsAnchor";

const NewsPage = () => (
	<Layout>
		<Seo title="May 2026" />
		<NewsHeader />
		<h2>May 2026</h2>

		<h3 className="blogdate">
			Friday, May 22, 2026
		</h3>

		<h4 className="blogitemtitle">
			<SleepyNewsAnchor num="1">Twenty years of <span className="italic">Seventeen Oh-Two Oh-Six</span></SleepyNewsAnchor>
		</h4>
		<div className="blogitembody">
			<p>
				My first official album, <span className="italic">Seventeen Oh-Two Oh-Six</span>, was released to online platforms in May 2006... twenty years ago!
				Am I celebrating? Not really, but I am acknowledging; so much time has passed,
				and as that music has been slipping more and more behind me, I have been stepping further and further onward.
			</p>

			<div className="main--centerwrapper p">
				<StaticImage
				src="../../images/catalog artwork/JRIVEST01 Seventeen Oh-Two Oh-Six - 20 yrs.png"
				alt="Jesse Rivest - Seventeen Oh-Two Oh-Six - cover - 20 years"
				placeholder="blurred"
				layout="constrained"
				className="main--centered"
				imgClassName="img--bordered-small"
				width={500}
				/>
			</div>

			<p>
				The other day <span className="bold">I quickly made a few videos</span> to mark the occasion.
				I chose two songs that I still play from the album, albeit differently than how I did that February 17th,
				so long ago.
				I recorded the first take of each song and went ahead with that...
			</p>
			<p className="card">
				<span className="card">
					"These are my songs, and this is how I performed them on May 19, 2026."
				</span>
			</p>
			<p>
				You'll know—whether you own a physical copy of the CD or you've read the <Link to="/music/01/">release page</Link>—that,
				although I recorded the songs that cold, winter day in February, I didn't offically release the album until May 2026.
				That's why I'm ackowledging twenty years in May rather than a few months back.
			</p>

			<p>
				The third video I made is of <span className="bold">me talking quite candidly, unscripted</span>,
				for ten minutes about this album and that time in my life.
				At the time of this writing, the <a href="//www.youtube.com/playlist?list=PLUnT5wM9jMYOVbks4BFGDsPQT_YbrODBF">three-video series is up at YouTube</a>.
			</p>

			<div className="main--centerwrapper p">
				<iframe
				className="main--centered"
				width="94%"
				height="315"
				style={{maxWidth: 560}}
				src="//www.youtube-nocookie.com/embed/CWP8eKzIoQs"
				title="YouTube video player"
				frameBorder="0"
				allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
				allowFullScreen
				/>
			</div>

			<p>
				I realized recently that the Wayback Machine has been archiving my site since 2004.
				I think I archived the various stages that my website has gone through over the decades,
				but not with intermediate snapshots like the Wayback Machine has.
				I found
				a <a href="//web.archive.org/web/20060721224034/http://www.jesserivest.com/~blog2/2006/04/recorded-music.html">particular snapshot</a> of
				what was my discography page at this particular time of interest;
				it has a <span className="bold">brief, detailed timeline of the process for this record</span>.
				Quite cool! I was tempted by nostalgia to spend more time there;
				alas, time is too short these days for such dwelling.
			</p>

			<p>
				(As I mention in the talking video of the series, I regret to have used the word "tits" so much at that time in my life;
				you'll see I used it wildly even in the timeline mentioned above.
				When you release music into the world, and doubly when you publish words for the world to read,
				there is no going back on any of it.)
			</p>

			<p>
				Although the album came out officially in May that year,
				I was already selling them to friends and (dare I say) fans from the day they arrived
				(which, according to the timeline, was April 26).
				I glanced through my emails from that time period and had to smile at my excitement and
				enthusiasm. <span className="bold">Were you one of the fine folk</span> emailing or meeting
				with me at that time and on that topic?
				If so, please <Link to="/contact/">contact me</Link> for a dose of nosalgia.
				(In the past year I received an email from Tina in Nelson, and it was wonderful to hear from her.)
			</p>
			<p>
				I was selling and signing those CDs for quite a few months in Canada, until I arrived in Wellington, NZ,
				at the beginning of October.
				I schlepped a big box or two of the CDs with me; they didn't sell so well there and, ultimately,
				I lost over 200 of them to time and space.
				And that's okay 😉.
			</p>

			<div className="main--centerwrapper p">
			</div>

		</div>

		<h3 className="blogdate">
			Friday, May 22, 2026
		</h3>

		<h4 className="blogitemtitle">
			<SleepyNewsAnchor num="2"><span className="italic">'Oumuamua</span>: a collab song</SleepyNewsAnchor>
		</h4>

		<p>
			My friend, Murilo Fabrino, and I released a collaboration song in the first week of January.
			I wrote a small blurb about it over at my <Link to="/collab/">collab page</Link>;
			if you've not yet heard it, how about now?
			The song's title gives away the inspiration behind the song's lyrics. 🌠🌌
		</p>
		<p>
			It should be at your preferred streaming service, as well as <a href="//open.spotify.com/album/2xGrqjBEWDfHmDQDVe9qqS?si=IZgS2mp_SUuhXpsdoJm62w">Spotify</a>.
		</p>

		<h3 className="blogdate">
			Friday, May 22, 2026
		</h3>

		<h4 className="blogitemtitle">
			<SleepyNewsAnchor num="3">Songwriting: an exercise</SleepyNewsAnchor>
		</h4>

		<p>
			I started this year off in a month-long, online songwriting workshop given by Blake Mills.
			Wow, wow, wow!
			I wrote three songs during that workshop and it got me back into the routine of exercise;
			yes, just like going to the gym, it takes time to become habit.
			At the end of that workshop I met (online) a musical colleague from a band that I admire (from my hometown!)
			who invited me into a songwriting group that he runs.
			Every two weeks we all get together to reveal the songs we wrote and then take on a new, common prompt for the next song.
			It's been great and I have been feeling so fortunate to meet these new peers, colleagues, and hopefully even friends.
			I've written another seven songs participating in this new group.
			I have an additional twenty-plus (unshared, unpublished) songs written over the past five years (maybe ten to fifteen are good?)...
			I've been wanting to make a new album.
			I think that's all I should say about it; very happy to be writing songs, I am!
		</p>

		<p>
		<Link to="/news/">Go back to the news index page</Link>
		</p>
	</Layout>
);

export default NewsPage;
